import React, { useState, useEffect, createContext } from "react";
import StartPage from "./pages/StartPage";
import GamePage from "./pages/GamePage";
import "./App.scss";
import "./Reset.scss";
export const GameContext = createContext();

function App() {
  const [currentStep, setCurrentStep] = useState(0);
  const PUBLIC_URL = process.env.PUBLIC_URL || "";

  const dataValue = {
    currentStep,
    setCurrentStep,
  };
  return (
    <GameContext.Provider value={dataValue}>
      <div className="App">
        <img
          className="background-image"
          src={`${PUBLIC_URL}/images/game_page_background.png`}
          alt="background"
        />
        {currentStep === 0 && <StartPage />}
        {currentStep === 1 && <GamePage />}
      </div>
    </GameContext.Provider>
  );
}

export default App;
